import { strictDraftRequest } from "./drafts";

const root = "api/v1/organisation/mailbox";
const segment = encodeURIComponent;
export const mailboxApi = {
  status: () => strictDraftRequest(`${root}/status`),
  connect: () => strictDraftRequest(`${root}/connect`, { method: "POST", body: {} }),
  // Email + App Password login (IMAP/SMTP); the server verifies it live before storing it sealed.
  connectPassword: (body) => strictDraftRequest(`${root}/password/connect`, { method: "POST", body }),
  complete: (code, state) => strictDraftRequest(`${root}/callback`, { method: "POST", body: { code, state } }),
  disconnect: () => strictDraftRequest(`${root}/disconnect`, { method: "POST", body: {} }),
  list: (params) => strictDraftRequest(`${root}/messages?${new URLSearchParams(params)}`),
  detail: (id) => strictDraftRequest(`${root}/messages/${segment(id)}`),
  attachment: (id, attachment) => strictDraftRequest(`${root}/messages/${segment(id)}/attachments/${segment(attachment)}`),
  send: (body) => strictDraftRequest(`${root}/send`, { method: "POST", body }),
  sendStatus: (key) => strictDraftRequest(`${root}/sends/${segment(key)}`),
  // Organisation-admin Google client settings. The secret is write-only; GET returns has_secret only.
  settings: () => strictDraftRequest(`${root}/settings`),
  saveSettings: (body) => strictDraftRequest(`${root}/settings`, { method: "PUT", body }),
  clearSettings: () => strictDraftRequest(`${root}/settings`, { method: "DELETE" }),
};